module.exports = __webpack_public_path__ + "static/media/e7fd47f0-319f-46ed-b933-b909cb223599_1.4807001ce780f84fee9af04dae074809.10c57393.jpeg";